module.exports = __webpack_public_path__ + "static/img/17.d9ccd16.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/01/17.jpeg
// module id = Ubyn
// module chunks = 7